import type {
  MapActionCategory,
  MapActionEvidenceState,
  MapFutureBriefLevel,
  MapMigrationWaveKey,
} from "../../enums/map";
import {
  MAP_ACTION_CATEGORY,
  MAP_ACTION_EVIDENCE_STATE,
  MAP_MIGRATION_WAVE_KEY,
} from "../../enums/map";

export const MAP_ACTION_CATEGORIES: MapActionCategory[] = [
  MAP_ACTION_CATEGORY.KEEP,
  MAP_ACTION_CATEGORY.IMPROVE,
  MAP_ACTION_CATEGORY.MERGE,
  MAP_ACTION_CATEGORY.CREATE,
  MAP_ACTION_CATEGORY.RETIRE,
];

export const MAP_MIGRATION_WAVES: Array<{
  key: MapMigrationWaveKey;
  label: string;
  description: string;
}> = [
  {
    key: MAP_MIGRATION_WAVE_KEY.FOUNDATION,
    label: "Wave 1 / Foundation",
    description:
      "Organising changes needed before dependent page and route work.",
  },
  {
    key: MAP_MIGRATION_WAVE_KEY.FLOW_FIXES,
    label: "Wave 2 / Flow fixes",
    description:
      "Supported improvements to important pages, patterns and onward routes.",
  },
  {
    key: MAP_MIGRATION_WAVE_KEY.SIMPLIFICATION,
    label: "Wave 3 / Structure simplification",
    description:
      "Consolidation and reorganisation that needs careful content review.",
  },
  {
    key: MAP_MIGRATION_WAVE_KEY.ADDITIONS,
    label: "Wave 4 / Architecture additions",
    description:
      "Later additions or unresolved directions that need more context.",
  },
];

export function mapActionCategoryLabel(value: MapActionCategory): string {
  return {
    keep: "Keep",
    improve: "Improve",
    merge: "Merge",
    create: "Create",
    retire: "Retire / Redirect",
  }[value];
}

export function mapActionCategoryEmptyText(
  category: MapActionCategory,
): string {
  if (
    category === MAP_ACTION_CATEGORY.KEEP ||
    category === MAP_ACTION_CATEGORY.RETIRE
  ) {
    return "This action type is not yet generated by the current deterministic planner.";
  }
  return `No draft ${mapActionCategoryLabel(category).toLowerCase()} action is surfaced in the current preview set.`;
}

export function mapActionEvidenceLabel(
  state: MapActionEvidenceState,
  severity: "critical" | "high" | "medium" | "low" | null,
): string {
  if (severity) {
    return `${severity.charAt(0).toUpperCase()}${severity.slice(1)}`;
  }
  if (state === MAP_ACTION_EVIDENCE_STATE.PROVISIONAL) return "Provisional";
  return "Structural evidence";
}

export function mapFutureBriefLabel(level: MapFutureBriefLevel): string {
  return `Potential future handoff: ${level}`;
}

export function mapCountLabel(
  count: number,
  singular: string,
  plural = `${singular}s`,
): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
